import { InfoHighlightBlockCms } from '@cerifi/ui/cms/info-highlight-block/info-highlight-block-cms'

import { InfoHighlightBlock as InfoHighlightBlockModel } from '../../../__generated/graphql.types'

const InfoHighlightBlock = ({
  content,
}: {
  content: InfoHighlightBlockModel
}) => {
  return (
    <InfoHighlightBlockCms
      id={content.sys.id}
      title={content.title}
      subtitle={content.subtitle}
      secondarySubtitle={content.secondarySubtitle}
      collection={(content.contentCollection?.items as any) || []}
      color={content.color}
    />
  )
}

export default InfoHighlightBlock
